import Login from './Login';

export const LoginConfig = {
    settings: {
        layout: {
            config: {
                navbar : {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer : {
                    display: false
                }
            }
        }
    },
    routes  : [
        {
            path     : '/login',
            component: Login
        }
    ]
};




// WEBPACK FOOTER //
// ./src/main/content/login/LoginConfig.js